const initialState = {
    str: ''
}

const seaBookNumberRed = (state = initialState, action) => {
    switch(action.type){
        case 'SEABOOK_NUMBER' : {
            return {
                ...state,
                str: action.str
            }
        }
        default: {
            return state
        }
    }
}

export default seaBookNumberRed